import { render, staticRenderFns } from "./UnitTransferComponent.vue?vue&type=template&id=bc5d0cfc&"
import script from "./UnitTransferComponent.vue?vue&type=script&lang=js&"
export * from "./UnitTransferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports